/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The CreateGroupResponse model module.
* @module model/CreateGroupResponse
* @version 2020-12-7
*/
export default class CreateGroupResponse {
    /**
    * Constructs a new <code>CreateGroupResponse</code>.
    * グループ登録レスポンス
    * @alias module:model/CreateGroupResponse
    * @class
    * @param id {Number} グループID
    * @param result {module:model/CreateGroupResponse.ResultEnum} 
    */

    constructor(id, result) {
        
        
        this['id'] = id;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>CreateGroupResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/CreateGroupResponse} obj Optional instance to populate.
    * @return {module:model/CreateGroupResponse} The populated <code>CreateGroupResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CreateGroupResponse();
                        
            
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
        }
        return obj;
    }

    /**
    * グループID
    * @member {Number} id
    */
    'id' = undefined;
    /**
    * @member {module:model/CreateGroupResponse.ResultEnum} result
    */
    'result' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
